import { Can, usePermissions } from "context/permissionContenxt";
import HangfireDashboard from "pages/Admin/Hangfire";
import Impersonation from "pages/Admin/Impersonation";
import DisbursementApplications from "pages/DisbursementApplications";
import DisbursementDetails from "pages/DisbursementDetails";
import ApartmentsExplorer from "pages/govnr/ApartmentsExplorer";
import ChildTransfersExplorer from "pages/govnr/ChildTransfers";
import DisbursementsExplorer from "pages/govnr/Disbursements";
import ExpensesExplorer from "pages/govnr/Expenses";
import TransferDetails from "pages/TransferDetails";
import { Navigate } from "react-router-dom";
import { LookupProvider } from "src/context/lookupContext";
import MainLayout from "src/layout/MainLayout";
import ApplicationDetails from "src/pages/ApplicationDetails";
import Applications from "src/pages/Applications";
import Expenses from "src/pages/Expenses";
import ExpenseTransactionDetails from "src/pages/Expenses/ExpenseTransactionDetails";
import MhdExpensesDetails from "src/pages/Expenses/MhdExpensesDetails";
import ApplicationsExplorer from "src/pages/govnr/Applications";
import PageNotFound from "src/pages/PageNotFound";

const HomeNavigation = () => {
  return (
    <>
      <Can I="View" a="MHD_Applications">
        <Navigate to="applications" />
      </Can>
      <Can I="View" a="MHD_GovnrApplications">
        <Navigate to="govnr/applications" />
      </Can>
      <Can I="View" a="MHD_GovnrExpenses">
        <Navigate to="govnr/expenses" />
      </Can>
      <Can I="View" a="MHD_GovnrDisbursements">
        <Navigate to="govnr/disbursements" />
      </Can>
      <Can I="View" a="MHD_GovnrChildTransfers">
        <Navigate to="govnr/transfers" />
      </Can>
    </>
  );
};

const PermissionWrapper = (props) => {
  const prm = usePermissions();
  const { action, subject, children } = props;
  if (prm.can(action, subject)) return <>{children}</>;
  return <PageNotFound />;
};

const AnyPermissionWrapper = (props) => {
  const prm = usePermissions();
  const { permissions, children } = props;
  if (permissions.some(({ action, subject }) => prm.can(action, subject)))
    return <>{children}</>;
  return <PageNotFound />;
};

const expenseApplicationAccessPermissions = [
  { action: "View", subject: "MHD_Applications" },
  { action: "View", subject: "MHD_GovnrApplications" },
  { action: "View", subject: "MHD_GovnrTransHeaderExpenses" },
];

const expenseTransactionCreateAccessPermissions = [
  { action: "View", subject: "MHD_Applications" },
];

const expenseTransactionAccessPermissions = [
  { action: "View", subject: "MHD_Applications" },
  { action: "Review", subject: "MHD_GovnrTransHeaderExpenses" },
];

const MainRoutes = () => {
  return [
    {
      path: "",
      element: <MainLayout />,
      children: [
        { path: "home", element: <Navigate to="/" /> },
        {
          path: "applications",
          element: (
            <PermissionWrapper action="View" subject="MHD_Applications">
              <Applications />
            </PermissionWrapper>
          ),
        },
        {
          path: "disbursement-applications",
          element: (
            <PermissionWrapper action="View" subject="MHD_Disbursements">
              <DisbursementApplications />
            </PermissionWrapper>
          ),
        },
        {
          path: "expenses",
          element: (
            <PermissionWrapper action="View" subject="MHD_Applications">
              <Expenses />
            </PermissionWrapper>
          ),
        },
        {
          path: "expenses/:applicationId",
          element: (
            <AnyPermissionWrapper
              permissions={expenseApplicationAccessPermissions}
            >
              <MhdExpensesDetails />
            </AnyPermissionWrapper>
          ),
        },
        {
          path: "expenses/:applicationId/transactions/new",
          element: (
            <AnyPermissionWrapper
              permissions={expenseTransactionCreateAccessPermissions}
            >
              <ExpenseTransactionDetails />
            </AnyPermissionWrapper>
          ),
        },
        {
          path: "expenses/:applicationId/transactions/:transHeaderId",
          element: (
            <AnyPermissionWrapper
              permissions={expenseTransactionAccessPermissions}
            >
              <ExpenseTransactionDetails />
            </AnyPermissionWrapper>
          ),
        },
        {
          path: "govnr/expenses",
          element: (
            <PermissionWrapper action="View" subject="MHD_GovnrExpenses">
              <ExpensesExplorer />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/disbursements",
          element: (
            <PermissionWrapper action="View" subject="MHD_GovnrDisbursements">
              <DisbursementsExplorer />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/transfers",
          element: (
            <PermissionWrapper action="View" subject="MHD_GovnrChildTransfers">
              <ChildTransfersExplorer />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/applications",
          element: (
            <PermissionWrapper action="View" subject="MHD_GovnrApplications">
              <ApplicationsExplorer />
            </PermissionWrapper>
          ),
        },
        {
          path: "govnr/apartments",
          element: (
            <PermissionWrapper action="View" subject="MHD_Apartments">
              <ApartmentsExplorer />
            </PermissionWrapper>
          ),
        },
        {
          path: "application/:id",
          element: (
            <LookupProvider>
              <ApplicationDetails />
            </LookupProvider>
          ),
        },
        {
          path: "disbursement-application/:id",
          element: (
            <LookupProvider>
              <DisbursementDetails />
            </LookupProvider>
          ),
        },
        {
          path: "transfer-application/:id",
          element: (
            <LookupProvider>
              <TransferDetails />
            </LookupProvider>
          ),
        },
        {
          path: "admin/hangfire",
          element: (
            <PermissionWrapper action="View" subject="HangfireDashboard">
              <HangfireDashboard />
            </PermissionWrapper>
          ),
        },
        {
          path: "admin/impersonation",
          element: (
            <PermissionWrapper action="View" subject="MHD_Impersonation">
              <Impersonation />
            </PermissionWrapper>
          ),
        },

        { path: "", element: <HomeNavigation /> },
        {
          path: "*",
          element: <PageNotFound />,
        },
      ],
    },
  ];
};

export default MainRoutes;
